import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { useTranslation } from 'react-i18next';
import { Route, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SelectCompanyFirstComponent from '../../components/SelectCompanyFirstComponent';
import { areFeatureTogglesFetched, getSelectedCompany } from '../../store/selectors';
import { Loader } from '../../components';
import Sharing from './EmailSharing';

const renderContent = (selectedCompany, match) => (
  !selectedCompany ? <SelectCompanyFirstComponent /> : (
    <>
      <Route
        exact
        path={`${match.url}`}
        component={Sharing}
      />
    </>
  )
);

export default () => {
  const match = useRouteMatch();
  const selectedCompany = useSelector(getSelectedCompany);
  const featureTogglesFetched = useSelector(areFeatureTogglesFetched);
  const { t } = useTranslation();

  return (
    <>
      <BreadcrumbsItem to="/orders">
        {t('BREADCRUMB.MONITORINGS')}
      </BreadcrumbsItem>
      <BreadcrumbsItem to="/email-sharings">
        {t('BREADCRUMB.SHARINGS')}
      </BreadcrumbsItem>
      {!featureTogglesFetched ? <Loader /> : renderContent(selectedCompany, match)}
    </>
  );
};
